import React from "react";
import { Route, Switch } from "react-router-dom/cjs/react-router-dom";
import { DocumentTitle } from "../../components/DocumentTitle/DocumentTitle";
import AlertsListContainer from "./AlertsListContainer";


const AlertsMain = ({ match }) => {
    return (
        <div className="column">
            <DocumentTitle title={"CARMA - Corrosion Rate Alerts"} />
            <div>
                <Switch>
                    <Route exact path={`${match.path}`} component={AlertsListContainer} />
                </Switch>
            </div>
        </div>
    )
}

export default AlertsMain